import React from 'react';
import { LuCheckCircle, LuMail, LuChevronRight, LuPartyPopper } from "react-icons/lu"; 
import "../../asset/css/register.css";
import { CircleCheck } from 'lucide-react';
import logo from "../../asset/img/white.png";


const RegisterSuccessful = () => {
  // 1. Retrieve and parse session data
  const sessionData = localStorage.getItem('user_session');
  const userSession = sessionData ? JSON.parse(sessionData) : null;
  
  // Destructure for easy access
  const firstName = userSession?.userInfo?.first_name || "there";
  const userEmail = userSession?.userInfo?.email || "your email";

  const handleContinue = () => {
    window.location.href = '/login';
  };

  return (
    <div className="register-wrapper">
      <nav className="reg-nav">
        <div className="reg-logo">
          <div>
      <img src={logo} className='img-fluid' style={{maxHeight:"40px",}} />
    {/* <div className="sub-brand  text-dark">Project Management Dashboard</div> */}
    </div>
        </div>
      </nav>

      <div className="reg-container">
        {/* Stepper showing Step 1 as completed */}
        <div className="stepper">
          <div className="step-item active">
            <div className="step-circle success">1</div>
            <span className="step-label">Account Created</span>
          </div>
          <div className="step-line active"></div>
          <div className="step-item inactive">
            <div className="step-circle">2</div>
            <span className="step-label">Choose Plan</span>
          </div>
          <div className="step-line active"></div>
          <div className="step-item  ">
            <div className="step-circle"><CircleCheck /></div>
            <span className="step-label">Completed</span>
          </div>

        </div>

        <div className="reg-card success-card">
          <div className="success-icon-wrapper">
            <LuPartyPopper className="celebrate-icon" />
          </div>

          <header className="reg-header">
            <h1>Welcome to Measro, {firstName}!</h1>
            <p>Your account has been created successfully.</p>
          </header>

          <div className="success-info-box">
            <div className="info-item">
              <LuMail className="info-icon" />
              <div>
                <strong>Account Created With Email</strong>
                <p>{userEmail}</p>
              </div>
            </div>
          </div>

          <div className="next-steps-section">
            <h3>What's next?</h3>
            <p>Now Login to your account.</p>
            {/* <p>To unlock your 14-day free trial and access GIS-based area measurements, please select a subscription plan. You won't be charged during the trial period.</p> */}
          </div>

          <div className="reg-footer justify-content-center">
            <button 
              type="button" 
              className="btn-continue w-100" 
              onClick={handleContinue}
            >
              Continue to Login   <LuChevronRight />
            </button>
          </div>
        </div>
      </div>

      <footer className="auth-footer-dark">
        <div className="footer-links">
          <a href="/privacy" style={{color:"#fff"}}>Privacy Policy</a>
          <a href="/terms" style={{color:"#fff"}}>Terms of Service</a>
        </div>
        <div className="footer-copyright">
          © 2025 Measro LLC. All rights reserved.
        </div>
      </footer>

      <style>
        {`
        /* Success State Specifics */
.success-card {
    text-align: center;
    padding: 50px 40px;
}

.success-icon-wrapper {
    width: 80px;
    height: 80px;
    background: #ecfdf5;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
}

.celebrate-icon {
    font-size: 40px;
    color: #10b981;
}

.success-info-box {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 20px;
    margin: 25px 0;
    text-align: left;
}

.info-item {
    display: flex;
    align-items: center;
    gap: 15px;
    justify-content: center;
}

.info-icon {
    font-size: 24px;
    color: #6366f1;
}

.info-item p {
    margin: 0;
    font-size: 14px;
    color: #64748b;
}

.next-steps-section {
    margin-bottom: 30px;
}

.next-steps-section h3 {
    font-size: 18px;
    color: #1e293b;
    margin-bottom: 10px;
}

.next-steps-section p {
    font-size: 14px;
    color: #475569;
    line-height: 1.6;
}

.step-circle.success {
    background: #10b981;
    border-color: #10b981;
    color: white;
}

.step-line.active {
    background: #10b981;
}
`}
      </style>
    </div>
  );
};

export default RegisterSuccessful;